import {Component, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {Subscription} from 'rxjs';
import {IconsComponent} from './icons.component';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ''
})
export class BasicSubscribableComponent extends IconsComponent implements OnDestroy {
    protected subscriptions: Subscription;

    public constructor() {
        super();
        this.subscriptions = new Subscription();
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
